import auth from './auth.json'
import validations from './validations.json'
import integrations from './integrations.json'
import products from './products.json'
import shipments from './shipments.json'
import inboundShipments from './inbound-shipments.json'
import ui from './ui.json'
import common from './common.json'
import billing from './billing.json'
import system from './system.json'
import support from './support.json'
import orders from './orders.json'
import fulfillment from './fulfillment.json'
import breadcrumbs from './breadcrumbs.json'
import forwardingShipments from './forwarding-shipments.json'
import returnShipments from './return-shipments.json'

export default {
  auth,
  validations,
  integrations,
  products,
  shipments,
  inboundShipments,
  forwardingShipments,
  returnShipments,
  ui,
  common,
  billing,
  system,
  support,
  orders,
  fulfillment,
  breadcrumbs,

  all_rights_reserved: 'Все права защищены',
  or: 'или',
  cancel_button: 'Отмена',
}
